<template>
	<Col
		:span="24"
		:offset="0"
		:xl="{ span: 12 }"
	>
		<Card :title="$t('account.generatePasswordCardTitle')">
			<Descriptions size="small" :column="1">
				<DescriptionsItem :label="$t('common.login')">{{ casterLogin }}</DescriptionsItem>
				<DescriptionsItem :label="$t('common.password')">{{ casterPassword }}</DescriptionsItem>
			</Descriptions>
			<template #actions>
				<Button
					type="primary"
					@click="onGenerateCasterPassword"
					:loading="isLoading"
				>
					{{ $t('account.passwordButtonLabel') }}
				</Button>
			</template>
		</Card>
	</Col>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { Col, Card, Button, Descriptions, DescriptionsItem, message } from 'ant-design-vue';
import { useUserStore } from '@/stores/user';
import Api from '@/api/Api';

export default {
	components: {
		Col, Card, Button, Descriptions, DescriptionsItem,
	},
	setup() {
		const { t } = useI18n();
		const isLoading = ref(false);
		const casterLogin = ref(useUserStore().username);
		const casterPassword = ref('');
		onMounted(() => {
			Api.profileGetDetails(data => {
				casterPassword.value = data.profile.caster_password;
			});
		});
		const onGenerateCasterPassword = () => {
			isLoading.value = true;
			Api.profileGenerateCasterPassword(data => {
				isLoading.value = false;
				casterPassword.value = data.caster_password;
				message.success(t('account.messages.passwordSuccess'));
			});
		}
		return {
			isLoading,
			casterLogin,
			casterPassword,
			onGenerateCasterPassword,
		};
	},
}
</script>
